// extracted by mini-css-extract-plugin
export default {"listingPage":"RIQzlgo","advert":"qMzsTDa"};